// src/pages/Publisher/Gamics/components/GamicsTable.tsx
import React from 'react';
import { Gamic } from '../types';
import GamTableRow from './GamTableRow';

interface Props {
  data: Gamic[];
  anchorEl: HTMLElement | null;
  rowIdx: string | null;
  onMenuOpen(e: React.MouseEvent<HTMLElement>, idx: string): void;
  onMenuClose(): void;
  onDelete(idx: string): void;
  onArchive(idx: string): void;
}

/* --- Column widths (min-widths) --- */
const colWidths = [
  'min-w-[56px]', // Image
  'min-w-[180px]', // Title
  'min-w-[96px]', // Date
  'min-w-[144px]', // Category
  'min-w-[104px]', // Engagement
  'min-w-[96px]', // Downloads
  'min-w-[80px]', // Wishlist
  'min-w-[48px]', // Likes
  'min-w-[56px]', // Shares
  'min-w-[96px]', // Comments
  'min-w-[104px]', // Status
  'min-w-[48px]', // More
];

const headers = [
  'Image',
  'Title',
  'Date',
  'Category',
  'Engagement',
  'Downloads',
  'Wishlist',
  'Likes',
  'Shares',
  'Comments',
  'Status',
  'More',
];

const GamicsTable: React.FC<Props> = ({
  data,
  anchorEl,
  rowIdx,
  onMenuOpen,
  onMenuClose,
  onDelete,
  onArchive,
}) => (
  <div className='relative h-full'>
    <div className='absolute inset-0 overflow-auto'>
      <table className='w-full min-w-max table-fixed text-left'>
        <colgroup>
          {colWidths.map((w, i) => (
            <col key={i} className={w} />
          ))}
        </colgroup>

        <thead className='sticky top-0 bg-white z-10 border-b'>
          <tr>
            {headers.map((h, i) => (
              <th
                key={i}
                className={`px-4 py-[18px] font-bold whitespace-nowrap ${
                  i === headers.length - 1 ? 'pr-[21px]' : ''
                }`}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data.map((g, i) => (
            <GamTableRow
              key={i}
              gamic={g}
              idx={g.id}
              anchorEl={anchorEl}
              rowIdx={rowIdx}
              onMenuOpen={onMenuOpen}
              onMenuClose={onMenuClose}
              onDelete={onDelete}
              onArchive={onArchive}
            />
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default GamicsTable;
